import { l } from '@manychat/manyui'

import { ChatThreadUser } from 'apps/chat/constants/LiveChatInterfaces'
import { ISubscriber } from 'common/audience/components/UserModal/interfaces'
import { OptInSources } from 'common/audience/constants/OptInAppTypes'

export function getSubscriberTitle(subscriber: ISubscriber | ChatThreadUser) {
  const { title, ig_username, tt_username, wa_id, optin_source } = subscriber
  const nameBySubscriberFields = [
    title,
    ig_username,
    tt_username,
    wa_id ? String(wa_id) : null,
  ].find(Boolean)

  if (optin_source === OptInSources.MESSENGER) {
    return l.translate('Subscribed with phone number')
  }

  return nameBySubscriberFields ?? l.translate('Unknown Contact')
}
